import "core-js/modules/es.array.push.js";
export default {
  data() {
    return {};
  },
  methods: {
    handleRouterTo(name) {
      this.$router.push({
        name: 'userCenter',
        params: {
          name
        }
      });
    },
    activatedLabel(name) {
      const componentsName = this.$route.params.name;
      return name === componentsName ? 'text-white' : '';
    }
  }
};